/**
 * El nombre de la plataforma, en un solo sitio.
 *
 * «Te Optimizo» es la marca (la consultora, teoptimizo.es) y «Oficina virtual»
 * el producto. En el logo va solo la marca (`components/shell/LogoTeOptimizo.tsx`);
 * en títulos, emails y metadatos, el nombre completo.
 *
 * Los textos traducibles no leen de aquí: viven en `messages/{es,en,de}.json`
 * con el nombre escrito. Esto es para lo que no pasa por i18n —metadatos,
 * `aria-label`, textos técnicos—.
 */
export const MARCA = "Te Optimizo";
export const PRODUCTO = "Oficina virtual";
export const NOMBRE_COMPLETO = `${PRODUCTO} · ${MARCA}`;
export const DOMINIO = "teoptimizo.es";
